import { render, staticRenderFns } from "./creareBuilding.vue?vue&type=template&id=04129cbd&scoped=true"
import script from "./creareBuilding.vue?vue&type=script&lang=js"
export * from "./creareBuilding.vue?vue&type=script&lang=js"
import style0 from "./creareBuilding.vue?vue&type=style&index=0&id=04129cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04129cbd",
  null
  
)

export default component.exports